import React, { useState } from "react";
import { toast } from "react-toastify";

export default function SettingsSideBar({ active, onChange }) {
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const links = [
    { key: "profile", label: "My Profile" },
    { key: "notifications", label: "Notifications" },
    { key: "privacy", label: "Settings & Privacy" },
  ];

  const handleDeleteClick = (e) => {
    e.preventDefault();
    setShowModal(true);
    setStep(1);
    setPassword("");
  };

  const handleCloseModal = () => {
    if (loading) return;
    setShowModal(false);
    setPassword("");
    setStep(1);
  };

  const handleNextStep = () => {
    setStep(2);
  };

  const handleConfirmDelete = async () => {
    if (!password.trim()) {
      toast.error("Please enter your password to continue.");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("Authentication token not found. Please log in again.");
      }

      const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
        `${TEST_BASE_URL}/user-profile`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: JSON.stringify({
            password: password,
          }),
        }
      );

      console.log(" Response Status:", response.status);
      console.log(
        " Response Headers:",
        Object.fromEntries(response.headers.entries())
      );

      const responseText = await response.text();
      console.log(" Raw Response Text:", responseText);

      if (!response.ok) {
        let errorMessage = "Failed to delete account";

        try {
          const errData = JSON.parse(responseText);

          if (errData.errors?.password) {
            errorMessage = "Incorrect password. Please try again.";
          } else if (errData.message) {
            errorMessage = errData.message;
          }

          if (response.status === 422) {
            errorMessage = "Incorrect password. Please try again.";
          }
        } catch {
          errorMessage = responseText || errorMessage;
        }

        throw new Error(errorMessage);
      }

      toast.success("Account deleted successfully.");

      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("userAvatar");

      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } catch (err) {
      toast.error(err.message || "Failed to delete account. Please try again.");
    } finally {
      setLoading(false);
    }
  };

    return (
    <>
      <h5 className="accounttext">Account Settings</h5>

      <div className="settings-side-bar">
        {links.map((link) => (
          <button
            key={link.key}
            type="button"
            onClick={() => onChange(link.key)}
            className={active === link.key ? "active linkbutton" : "linkbutton"}
          >
            {link.label}
          </button>
        ))}

        <button
          type="button"
          onClick={handleDeleteClick}
          className={
            active === "delete"
              ? "active delete-link linkbutton"
              : "delete-link linkbutton"
          }
        >
          Delete Account
        </button>

        <p className="pt-2 textcenter">
          <small>
            Please read our{" "}
            <a
              href="https://www.rccgbournemouth.org/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
              className="privacy-link"
            >
              <small>
                <u>Privacy Notice</u>
              </small>
            </a>{" "}
            to learn how we protect your personal data.
          </small>
        </p>
      </div>

      {showModal && (
        <div className="delete-modal-overlay" onClick={handleCloseModal}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 84 92"
                fill="none"
              >
                <path
                  d="M73.875 18.375L71.2412 60.9816C70.5682 71.8674 70.2318 77.3103 67.5032 81.2234C66.1542 83.1581 64.4173 84.791 62.403 86.0181C58.329 88.5 52.8757 88.5 41.9692 88.5C31.0482 88.5 25.5878 88.5 21.511 86.0135C19.4954 84.7841 17.758 83.1484 16.4094 81.2106C13.6817 77.291 13.3527 71.8405 12.6946 60.9394L10.125 18.375"
                  stroke="white"
                  strokeWidth="6.375"
                  strokeLinecap="round"
                />
                <path
                  d="M3.75 18.375H80.25M59.2368 18.375L56.3355 12.3898C54.4082 8.41409 53.4446 6.42622 51.7823 5.18642C51.4136 4.91142 51.0231 4.66681 50.6148 4.45498C48.7741 3.5 46.565 3.5 42.1467 3.5C37.6175 3.5 35.3529 3.5 33.4817 4.49501C33.0669 4.71553 32.6712 4.97006 32.2985 5.25596C30.617 6.54598 29.6777 8.6066 27.7991 12.7278L25.2249 18.375"
                  stroke="white"
                  strokeWidth="6.375"
                  strokeLinecap="round"
                />
                <path
                  d="M31.375 65.125L31.375 39.625"
                  stroke="white"
                  strokeWidth="6.375"
                  strokeLinecap="round"
                />
                <path
                  d="M52.625 65.125L52.625 39.625"
                  stroke="white"
                  strokeWidth="6.375"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            {step === 1 ? (
              <>
                <h3>Are you sure you want to delete your account?</h3>
                <p>This action is permanent and cannot be undone.</p>
                <div className="delete-buttons">
                  <button
                    className="cancel-btn"
                    onClick={handleCloseModal}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="delete-btn"
                    onClick={handleNextStep}
                    type="button"
                  >
                    Yes, Delete
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3>Confirm your password to delete account</h3>
                <p>This action is permanent and cannot be undone.</p>

                <label htmlFor="confirmPassword" className="password-label">
                  Confirm Password
                </label>

                <div className="password-wrapper">
                  <input
                    id="confirmPassword"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && password && !loading) {
                        handleConfirmDelete();
                      }
                    }}
                    className="form-control"
                    placeholder="Enter your password"
                    disabled={loading}
                    autoFocus
                    required
                  />

                  <span
                    className="password-eye"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeWidth="2"
                          d="M13.875 18.825a10.05 10.05 0 01-2.4.3C5.7 19.125 1.875 12 1.875 12a17.8 17.8 0 014.207-5.355M9.75 9.75a2.25 2.25 0 103.182 3.182"
                        />
                        <path strokeWidth="2" d="M6 6l12 12" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeWidth="2"
                          d="M12 4.5c7.2 0 10.5 7.5 10.5 7.5s-3.3 7.5-10.5 7.5S1.5 12 1.5 12 4.8 4.5 12 4.5z"
                        />
                        <circle cx="12" cy="12" r="3" strokeWidth="2" />
                      </svg>
                    )}
                  </span>
                </div>

                <div className="delete-buttons">
                  <button
                    className="cancel-btn"
                    onClick={handleCloseModal}
                    disabled={loading}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="delete-btn"
                    onClick={handleConfirmDelete}
                    disabled={loading || !password}
                    type="button"
                  >
                    {loading ? "Deleting..." : "Delete Account"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
